import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as n, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDectHandset",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, d, u, _, a) {
  return i(), n("svg", {
    "aria-label": d.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--dect-handset"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dect Handset",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 2A1.5 1.5 0 0 1 4.5.5h3A1.5 1.5 0 0 1 9 2v8a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 3 10V2Zm5 3V2a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 4 2v3h4ZM4 6h4v4a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 4 10V6Zm.793-3.5a.5.5 0 0 1 .5-.5h1.414a.5.5 0 0 1 0 1H5.293a.5.5 0 0 1-.5-.5Zm-.168 5a.5.5 0 0 1 .5-.5h.004a.5.5 0 0 1 .001 1h-.004a.5.5 0 0 1-.501-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5ZM4.625 9a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, h);
}
const Z = /* @__PURE__ */ o(c, [["render", m]]);
export {
  Z as default
};
//# sourceMappingURL=dect-handset.js.map
